<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router';
import { NuxtLink } from '#components';
import Icon from './Icon.vue';
import Pill from './Pill.vue';

const props = defineProps<{
	to?: RouteLocationRaw;
	label: string;
	icon?: string;
	severity?: 'secondary' | 'error' | undefined;
	soon?: boolean;
	external?: boolean;
	target?: '_blank' | '_self' | '_parent' | '_top';
}>();
</script>

<template>
	<component
		class="nav__link"
		:class="{
			[`nav__link--${props.severity}`]: props.severity,
		}"
		:to="props.to"
		:type="props.to ? undefined : 'button'"
		:external="props.to ? props.external : undefined"
		:target="props.to ? props.target : undefined"
		:is="props.to ? NuxtLink : 'button'"
	>
		<Icon :name="props.icon" v-if="props.icon" />
		<span>{{ props.label }}</span>
		<Pill label="Soon" v-if="props.soon" />
	</component>
</template>
